import { createContext, useState } from 'react'

import { useSocket } from 'Components/Hooks/UseSocket'
import PositionedSnackbar from 'Components/UI/Atoms/PositionedSnackbar'
import config from 'config'
import { getToken } from 'service/helpers/localstorage'

export const SocketContext = createContext()

export const SocketProvider = ({ children }) => {
  const [auth, setAuth] = useState(getToken() ? true : false)

  const { socket, online, notification } = useSocket(config.API_URL, auth)
  return (
    <SocketContext.Provider value={{ socket, online, notification, setAuth }}>
      {children}
      <PositionedSnackbar notification={notification} />
    </SocketContext.Provider>
  )
}
